import { useCallback } from 'react';
import confetti from 'canvas-confetti';

export function useConfetti() {
  const celebrate = useCallback(() => {
    // Default confetti burst
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });
  }, []);

  const celebrateFromElement = useCallback((element: HTMLElement) => {
    const rect = element.getBoundingClientRect();
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = (rect.top + rect.height / 2) / window.innerHeight;

    confetti({
      particleCount: 100,
      spread: 70,
      origin: { x, y }
    });
  }, []);

  return { celebrate, celebrateFromElement };
}
